import { isRecordEmpty } from 'hx-util';
import { useEffect, useState } from 'react';
export var useTrackVideo = function (_a) {
    var videoTrack = _a.videoTrack;
    var _b = useState(false), videoOn = _b[0], setVideoOn = _b[1];
    useEffect(function () {
        if (isRecordEmpty(videoTrack))
            return;
        setVideoOn(videoTrack.isEnabled);
        var handleVideoDisabled = function () {
            setVideoOn(false);
        };
        var handleVideoEnabled = function () {
            setVideoOn(true);
        };
        videoTrack.on('disabled', handleVideoDisabled);
        videoTrack.on('enabled', handleVideoEnabled);
        return function () {
            videoTrack.off('disabled', handleVideoDisabled);
            videoTrack.off('enabled', handleVideoEnabled);
        };
    }, [videoTrack]);
    return { videoOn: videoOn };
};
